// extracted by mini-css-extract-plugin
export default {"table":"Returned_table__txIKH"};